import { Box, Group, rem, Image, Text, SimpleGrid } from "@mantine/core";

export default function StatisticsLegand(props) {
  return (
    <Box {...props}>
      <SimpleGrid cols={props.cols ?? 1} spacing={props.spacing}>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <Image src={"img/new_db_images/6.png"} />
          </Box>
          <Text fw={600}>{"P < 5%"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <Image src={"img/new_db_images/4.png"} />
          </Box>
          <Text fw={600}>{"P < 2%"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <Image src={"img/new_db_images/3.png"} />
          </Box>
          <Text fw={600}>{"P < 1%"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1 }}>
            <Image src={"img/new_db_images/0.png"} />
          </Box>
          <Text fw={600}>{"P < 0.5%"}</Text>
        </Group>
      </SimpleGrid>
    </Box>
  );
}
